import ReactDOM from 'react-dom';

import { forwardPropsToState } from 'utils/react_utils';

import InputAutocompleteResult from './input_autocomplete_result';

const Realize = {
	InputAutocomplete: window.InputAutocomplete,
	InputAutocompleteSelect: window.InputAutocompleteSelect
};

@forwardPropsToState([
	{ prop: 'value', defaultValue: [] },
	{ prop: 'options', defaultValue: [] },
	{ state: 'optionsCache', prop: 'options', defaultValue: [] },
])
export default class InputAutocomplete extends Realize.InputAutocomplete {

	static defaultProps = {
		...Realize.InputAutocomplete.defaultProps,
		inputAutoCompleteSelectComponent: Realize.InputAutocompleteSelect
	};

	constructor(props) {
		super(props);
		this.selectedOptions = InputAutocomplete.prototype.selectedOptions.bind(this);
		this.handleSelect = InputAutocomplete.prototype.handleSelect.bind(this);
		this.handleClear = InputAutocomplete.prototype.handleClear.bind(this);
		this.hideResult = InputAutocomplete.prototype.hideResult.bind(this);
	}

	hideResult() {
		$(document).off('click', this.handleDocumentClick);

		const resultComponent = this.getResultComponent();
		const $resultNode = $(ReactDOM.findDOMNode(resultComponent));
		const $searchInput = $resultNode.find('input[type=text]');

		$resultNode.hide();
		$searchInput.val('');

		this.state.loadParams[this.props.searchParam] = '';

		resultComponent.refs.inputSearch.setState({
			value: ''
		});

		this.setState({
			active: 0,
			searchValue: ''
		});
	}

	getResultComponent() {
		return this.refs.result;
	}

	componentDidMount() {
		if(this.props.optionsUrl) {
			if(!!this.props.dependsOn) {
				this.listenToDependableChange();
				this.loadDependentOptions(null, true);
			} else {
				this.loadOptions();
			}
		}

		if(this.state.value.length > 0) {
			this.triggerDependableChanged();
		}

		this.tabAutoComplete();
		this.focusInputReadOnly();
		this.removeFocusInputDisabled();
	}

	componentDidUpdate(){
		this.tabAutoComplete();
		this.removeFocusInputDisabled();
		this.focusInputReadOnly();
	}

	tabAutoComplete(){
		if($('#documentModal').is(':visible') === false){
			let inputList = $(`#input__${this.props.id} #autocomplete_select_${this.props.id}`);
			let btnList = $(`#input__${this.props.id} .caret`);
			inputList.attr('tabindex', '-1');
			btnList.attr('tabindex', '0');

			btnList.keydown((e) => {
				if(e.which === 32 || e.which === 13){
					btnList[0].click();
				}

				if(e.shiftKey){
					$(`#boxSearch__${this.props.id}`).hide();
				}
			});

			$(`#input__${this.props.id} .input-autocomplete__clear-button`).attr('tabindex', '0');
		}
	}

	focusInputReadOnly(){
		let readOnly = this.props.readOnly;
		if(readOnly){
			let id = this.props.id;
			let input = $(`#autocomplete_select_${id}`);
			let btnList = $(`#input__${this.props.id} .caret`);

			btnList.removeAttr('tabindex');
			input.attr('tabindex', '0');
			input.on('focus', () => { input.select() });
		}
	}

	removeFocusInputDisabled(){
		let disabled = this.props.disabled;

		if(disabled){
			let id = this.props.id;
			let input = $(`#input__${id} .caret`);
			input.removeAttr('tabindex');
		}
	}

	render() {
		return (
			<div className={this.className()} ref="container">
				{this.renderInputAutcompleteSelect()}
				{this.renderInputAutocompleteResult()}
                {this.renderInputAutocompleteValues()}
			</div>
		);
	}

	renderInputAutcompleteSelect() {
		const Component = this.props.inputAutoCompleteSelectComponent;

		return (
			<Component
				{...this.propsWithoutCSS()}
				//disabled={this.isDisabled()}
				selectedOptions={this.selectedOptions()}
				// onFocus={this.tabAutoComplet.bind(this)}
				onFocus={this.showResult}
			/>
		);
	}

	renderInputAutocompleteResult() {
		return (
			<InputAutocompleteResult
				id={this.props.id}
				selectedOptions={this.selectedOptions()}
				options={this.getResultOptions()}
				active={this.state.active}
				searchValue={this.state.searchValue}
				actionButtons={this.props.actionButtons}
				onKeyDown={this.handleSearchNavigation}
				onChange={this.searchOptions}
				onSelect={this.handleSelect}
				onClear={this.handleClear}
				onOptionMouseEnter={this.handleOptionMouseEnter}
				ref="result"/>
		);
	}

	renderInputAutocompleteValues() {
		return (
			<InputAutocompleteValues
				id={this.props.id}
				name={this.props.name}
				multiple={this.props.multiple}
				selectedOptions={this.selectedOptions()}
				ref="select" />
		);
	}

	selectedOptions() {
		const value = this.ensureIsArray(this.state.value).map(val => val.toString());
		return this.state.optionsCache.filter(option => value.includes(option.value));
	}

	handleClear() {
		this.setState({
			value: []
		}, () => {
			this.triggerDependableChanged();
			this.props.onChange(null, [], this);
		});

		if(!this.props.multiple) {
			this.hideResult();
		}

		if(!!this.props.onSelect) {
			this.props.onSelect(this.props.id, [], []);
		}
	}

	handleSelect(event, option) {
		let value = this.ensureIsArray(this.state.value);

		if (!value.includes(option.value)) {
			if (!this.props.multiple) value = [];
			value.push(option.value);
		} else {
			let indexValue = value.indexOf(option.value);
			if (indexValue > -1) value.splice(indexValue, 1);
		}

		this.forceUpdate();
		this.triggerDependableChanged();

		if(!this.props.multiple)
		this.hideResult();

		if(!!this.props.onSelect)
		this.props.onSelect(this.props.id, value, this.state.loadData);

		this.props.onChange(event, value, this);
		this.setState({ value });
	}
}
